import { Component, input } from '@angular/core';
import { Dimension2d, WordRect } from '../../page-overlay/model';
import { OverlayRectComponent } from '../../page-overlay/overlay-rect/overlay-rect.component';

@Component({
  selector: 'shared-dp-text-selection-overlay',
  imports: [OverlayRectComponent],
  templateUrl: './text-selection-overlay.component.html',
})
export class TextSelectionOverlayComponent {
  readonly selectedWordsRect = input.required<WordRect[]>();
  readonly lasso = input<WordRect>();
  readonly showTextSelectionOverlay = input.required<boolean>();
  readonly dimension = input.required<Dimension2d>();
}
